import React from 'react';
import { useFormatsDialogMenu } from 'src/hooks/formatsDialogMenu';

import { Space } from '@sravni/react-design-system';

import { MenuItem } from './components/Item';
import { SubscribtionMenuItem } from './components/subscriptionItem';

interface Props {
  hideMenuController: () => void;
  subscriptionPopupState: [number, (value: number) => void];
}

export const FormatsMenu = ({ hideMenuController, subscriptionPopupState }: Props) => {
  const formats = useFormatsDialogMenu();

  return (
    <Space direction={'vertical'}>
      {formats
        .filter((format) => format.isVisible)
        .map((item) =>
          item.name === 'Рассылка Сравни' ? (
            <SubscribtionMenuItem
              hideMenuController={hideMenuController}
              item={item}
              subscriptionPopupState={subscriptionPopupState}
            />
          ) : (
            <MenuItem item={item} onClick={hideMenuController} />
          ),
        )}
    </Space>
  );
};
